import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AvailabilityDTO } from '../../shared/entity-restriction-checkbox/form-field/entity-restriction-checkbox-form-field.component';
import { EntityRestrictionsService } from '../../services/entity-restrictions.service';
import { MenuDTO } from '../../../../../system/system-dtos';
import { MenuUtils } from '../../../../../common/utils/menu-utils';

@Component({
  selector: 'app-entity-restriction-manager',
  templateUrl: './entity-restriction-manager.component.html',
  styleUrls: ['./entity-restriction-manager.component.scss'],
  standalone: false,
})
export class EntityRestrictionManagerComponent implements OnInit {
  changes: AvailabilityDTO[] = [];

  @Input() menuConfig: MenuDTO;

  @Output() successfulUpdate: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private service: EntityRestrictionsService,
    private dialog: MatDialog,
    private http: HttpClient,
    private toastrService: ToastrService
  ) {
    service.asObservable().subscribe((d) => {
      this.changes = d;
    });
  }

  ngOnInit(): void {}

  save() {
    this.openDialog();
  }

  openDialog() {
    const dialogRef = this.dialog.open(EntityRestrictionDialogComponent, {
      data: this.changes,
    });
    let editUrl = this.menuConfig.entityGroup.dataSources[0]?.definition?.editUrl ?? '/country-restrictions/update';
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.http.post(editUrl, this.changes).subscribe(() => {
          this.toastrService.success(`Availability updated.`);
          this.service.clear();
          this.successfulUpdate.emit();
        });
      }
    });
  }
}

@Component({
  selector: 'app-entity-restriction-dialog',
  templateUrl: './entity-restriction-dialog.component.html',
  styleUrls: ['./entity-restriction-dialog.component.scss'],
  standalone: false,
})
export class EntityRestrictionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EntityRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AvailabilityDTO[]
  ) {}
}
